import * as React from "react";
const SvgLabel = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M10.3327 3.33334C10.7793 3.33334 11.1793 3.55334 11.4193 3.89334L14.3327 8.00001L11.4193 12.1067C11.1793 12.4467 10.7793 12.6667 10.3327 12.6667L2.99935 12.66C2.26602 12.66 1.66602 12.0667 1.66602 11.3333V4.66668C1.66602 3.93334 2.26602 3.34001 2.99935 3.34001L10.3327 3.33334ZM2.99935 11.3333H10.3327L12.6993 8.00001L10.3327 4.66668H2.99935V11.3333Z",
	fill: "currentColor"
}));
export default SvgLabel;
